/**
 * @generated SignedSource<<306bb690ce8fe43472ec76c4dc2558d7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cancelationEndDate"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cancelationStartDate"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "terminalId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "terminalId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gtfsId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v7 = [
  (v4/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "alertSeverityLevel",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "effectiveEndDate",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "effectiveStartDate",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "alertHash",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "stopRoutes_TerminalPageTabContainer_Query",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Stop",
        "kind": "LinkedField",
        "name": "station",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "cancelationEndDate",
                "variableName": "cancelationEndDate"
              },
              {
                "kind": "Variable",
                "name": "cancelationStartDate",
                "variableName": "cancelationStartDate"
              }
            ],
            "kind": "FragmentSpread",
            "name": "TerminalPageTabContainer_station"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "QueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "stopRoutes_TerminalPageTabContainer_Query",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Stop",
        "kind": "LinkedField",
        "name": "station",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Stop",
            "kind": "LinkedField",
            "name": "stops",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "types",
                    "value": [
                      "STOP",
                      "ROUTES"
                    ]
                  }
                ],
                "concreteType": "Alert",
                "kind": "LinkedField",
                "name": "alerts",
                "plural": true,
                "selections": (v7/*: any*/),
                "storageKey": "alerts(types:[\"STOP\",\"ROUTES\"])"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "types",
                "value": [
                  "STOP"
                ]
              }
            ],
            "concreteType": "Alert",
            "kind": "LinkedField",
            "name": "alerts",
            "plural": true,
            "selections": (v7/*: any*/),
            "storageKey": "alerts(types:[\"STOP\"])"
          },
          {
            "alias": null,
            "args": [
              {
                "items": [
                  {
                    "fields": [
                      {
                        "kind": "Variable",
                        "name": "end",
                        "variableName": "cancelationEndDate"
                      },
                      {
                        "kind": "Variable",
                        "name": "start",
                        "variableName": "cancelationStartDate"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "timeRanges.0"
                  }
                ],
                "kind": "ListValue",
                "name": "timeRanges"
              }
            ],
            "concreteType": "StopCallOnTripOnServiceDate",
            "kind": "LinkedField",
            "name": "canceledCalls",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TripOnServiceDate",
                "kind": "LinkedField",
                "name": "tripOnServiceDate",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "serviceDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Trip",
                    "kind": "LinkedField",
                    "name": "trip",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Pattern",
                        "kind": "LinkedField",
                        "name": "pattern",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Stop",
                            "kind": "LinkedField",
                            "name": "stops",
                            "plural": true,
                            "selections": [
                              (v5/*: any*/),
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "StopCall",
                "kind": "LinkedField",
                "name": "stopCall",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "stopLocation",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v5/*: any*/)
                        ],
                        "type": "Stop",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v4/*: any*/)
                        ],
                        "type": "Node",
                        "abstractKey": "__isNode"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8a43c4dd2cc3b2c0fcba7c9ef4e8c7dd",
    "id": null,
    "metadata": {},
    "name": "stopRoutes_TerminalPageTabContainer_Query",
    "operationKind": "query",
    "text": "query stopRoutes_TerminalPageTabContainer_Query(\n  $terminalId: String!\n  $cancelationStartDate: OffsetDateTime!\n  $cancelationEndDate: OffsetDateTime!\n) {\n  station(id: $terminalId) {\n    ...TerminalPageTabContainer_station_4gwf7I\n    id\n  }\n}\n\nfragment TerminalPageTabContainer_station_4gwf7I on Stop {\n  id\n  gtfsId\n  code\n  stops {\n    id\n    gtfsId\n    alerts(types: [STOP, ROUTES]) {\n      id\n      alertSeverityLevel\n      effectiveEndDate\n      effectiveStartDate\n      alertHash\n    }\n  }\n  alerts(types: [STOP]) {\n    id\n    alertSeverityLevel\n    effectiveEndDate\n    effectiveStartDate\n    alertHash\n  }\n  canceledCalls(timeRanges: [{start: $cancelationStartDate, end: $cancelationEndDate}]) {\n    tripOnServiceDate {\n      serviceDate\n      trip {\n        pattern {\n          code\n          stops {\n            gtfsId\n            id\n          }\n          id\n        }\n        id\n      }\n    }\n    stopCall {\n      stopLocation {\n        __typename\n        ... on Stop {\n          gtfsId\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

node.hash = "529fa6408fbebe3fee73187a9af43f3b";

export default node;
